import axiosRetry from 'axios-retry'
import axios from 'axios'

axiosRetry(axios, { retries: 3 })

// Exponential back-off retry delay between requests
axiosRetry(axios, { retryDelay: axiosRetry.exponentialDelay })

// Custom retry delay
axiosRetry(axios, {
  retryDelay: (retryCount) => {
    return retryCount * 1000
  },
})
